// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  left: 50% !important;
  top: 50% !important;
  z-index: 999;
  transform: translate(-50%, -50%);
  --shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 0 rgba(0, 0, 0, 0), 0 0 rgba(0, 0, 0, 0), var(--shadow);
  box-shadow: var(--ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--shadow);
  background-color: white;
  border-radius: 30px;
  overflow: hidden;
  padding-bottom: 4rem;
  max-width: 500px;
  height: auto !important;
  height: initial !important;
}
.modal--confirm {
  padding-bottom: 2.25rem;
}
.modal--show {
  display: block !important;
}
.modal__header {
  height: 75px;
}
.modal__body {
  width: 100%;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal__body h1 {
  margin-top: 1rem;
  font-size: 2.5rem;
  font-weight: 800;
  font-style: italic;
}
.modal__body h3 {
  margin-top: 1rem;
  color: #1a2d47;
  font-weight: bold;
  font-size: 1.25rem;
  text-align: center;
}
.modal__body p {
  margin-top: 1rem;
  color: #1a2d47;
  font-size: 15px;
  text-align: center;
}
.modal__edit {
  width: 100%;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal__edit h1 {
  margin-top: 1rem;
  font-size: 2.5rem;
  font-weight: 800;
  font-style: italic;
}
.modal__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  padding: 1.5rem 3rem 0 3rem;
}

.modal-overlay {
  z-index: 998;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/styles.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,yEAAA;EACA,qEAAA;EAAA,oHAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EAAA,0BAAA;AACJ;AACI;EACI,uBAAA;AACR;AACI;EACI,yBAAA;AACR;AAEI;EACI,YAAA;AAAR;AAGI;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADR;AAGQ;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AADZ;AAIQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAFZ;AAKQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAHZ;AAOI;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AALR;AAOQ;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AALZ;AASI;EACI,aAAA;EACA,8BAAA;EACA,wBAAA;EAAA,mBAAA;EACA,2BAAA;AAPR;;AAWA;EACI,YAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;AARJ","sourcesContent":[".modal {\n    position: fixed;\n    left: 50% !important;\n    top: 50% !important;\n    z-index: 999;\n    transform: translate(-50%, -50%);\n    --shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n    box-shadow: var(--ring-offset-shadow, 0 0 #0000), var(--ring-shadow, 0 0 #0000), var(--shadow);\n    background-color: white;\n    border-radius: 30px;\n    overflow: hidden;\n    padding-bottom: 4rem;\n    max-width: 500px;\n    height: unset !important;\n\n    &--confirm {\n        padding-bottom: 2.25rem;\n    }\n    &--show {\n        display: block !important;\n    }\n\n    &__header {\n        height: 75px;\n    }\n\n    &__body {\n        width: 100%;\n        padding: 0 2rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        h1 {\n            margin-top: 1rem;\n            font-size: 2.5rem;\n            font-weight: 800;\n            font-style: italic;\n        }\n\n        h3 {\n            margin-top: 1rem;\n            color: #1a2d47;\n            font-weight: bold;\n            font-size: 1.25rem;\n            text-align: center;\n        }\n\n        p {\n            margin-top: 1rem;\n            color: #1a2d47;\n            font-size: 15px;\n            text-align: center;\n        }\n    }\n\n    &__edit {\n        width: 100%;\n        padding: 0 2rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        h1 {\n            margin-top: 1rem;\n            font-size: 2.5rem;\n            font-weight: 800;\n            font-style: italic;\n        }\n    }\n\n    &__actions {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        column-gap: 1.25rem;\n        padding: 1.5rem 3rem 0 3rem;\n    }\n}\n\n.modal-overlay {\n    z-index: 998;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000000, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
